import cookieHelper from "./cookieHelper";

const _interval = [];

const AuthInterval = {
  createInterval() {
    const intervalTime = 1000 * 1; //  minutes
    if (_interval.length === 0) {
      let authVm = this;
      let newInterval = window.setInterval(function () {
        if (!cookieHelper.getTokenFromCookie("StarJwtTokenCookieName")) {
          window.sessionStorage.removeItem("st-user");
          window.sessionStorage.removeItem("st-header"); // Removing st-header also since header has a reference to the user object.
          authVm.removeInterval();
          window.location.reload();
        }
      }, intervalTime);
      _interval.push(newInterval);
    }
  },

  removeInterval() {
    if (_interval.length > 0) {
      window.clearInterval(_interval.pop());
    }
  },
};

Object.freeze(AuthInterval);
export default AuthInterval;
